import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { FacultyCard } from './components/Card/FacultyCard';
import { getFacultyPagedOptions } from './model/FacultyQuery';

export function FacultyBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { pagination, useTotalElements, ...paginationProps } = usePagination();
  const { search, searchProps } = useSearch();
  const { data } = useSuspenseQuery(getFacultyPagedOptions({ ...pagination, sortDirection, search }));
  useTotalElements(data);

  return (
    <Browse
      actions={<AddButtonLink />}
      title={t('faculties.title')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('faculties.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('faculties.sortedByName')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={faculty => (
        <FacultyCard
          key={faculty.id}
          faculty={faculty}
          to={`${faculty.id}`}
        />
      )}
    />
  );
}
